import React from 'react';

export const StudentResponse = () => {


    return (
        <React.Fragment>
            <div className="confirmation" >
                <div className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12" >
                                <div className="card card-primary card-outline">
                                    <div className="card-header">
                                        <h5 className="card-title m-0">Academic2.umn.ac.id</h5>
                                    </div>
                                    <div className="card-body">
                                        <p>
                                            <h6 className="card-title"> You don't have permission to access this page.</h6>
                                        </p>
                                        <p></p>
                                        <p className="card-text">
                                            <br/>Please make a request to IT helpdesk:
                                            <ul className="ulcustom">
                                                <li>I have a request - Click <b>Request a Service</b> button</li>
                                                <li>Click <b>2. Software/Sistem Informasi</b></li>
                                                <li>Click <b>3. Request Menu Access Sistem Informasi</b></li>
                                                <li>Input your request</li>
                                            </ul>
                                        </p>
                                        <a href="https://academic2.umn.ac.id/api/academic/user/login" className="btn btn-info" type="button">Login SSO</a>&nbsp;&nbsp;
                                        <a href="https://helpdesk.umn.ac.id/" className="btn btn-warning" type="button">Helpdesk</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default StudentResponse;